/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface EnforcementHistoryRecord { 
    id?: number;
    org_id?: string;
    service_type?: ServiceTypeEnum;
    start_state?: object;
    end_state?: object;
    user_id?: string;
    created_ts?: Date;
    updated_ts?: Date;
}
export namespace EnforcementHistoryRecord {
}


